/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../../config/config"
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import axios from "axios";

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import DashboardSection from '../../DashboardContainer/DashboardSection';
import DomainTile from '../../DomainTile/DomainTile';
import ReusableTable from '../../ReusableTable/ReusableTable';
import styles from './BankReconciliation.module.css';

const WeekOptions = [
  { value: 'undefined', label: 'Select' },
  { value: 'All', label: '-All-' },
  ...Array.from({ length: 52 }, (_, i) => ({
    value: `W${i + 1}`,
    label: `Week ${i + 1}`
  }))
];

const { API_BASE_URL } = config;

const InterCompanyReconcilationDrilldown = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    entityData: null,
    subEntityData: [],
    yearData: null,
    monthData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [entityOptions, setEntityOptions] = useState([]);
  const [subEntityOptions, setSubEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [entity, setEntity] = useState(null);
  const [subEntity, setSubEntity] = useState([]);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState([]);

  const [week, setWeek] = useState(WeekOptions[0]);

  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [interCompPage, setInterCompPage] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const itemsPerPage = 100;
  const [selectedPage, setSelectedPage] = useState(1);

  const history = useHistory()

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleSubEntityChange = (selected) => {
    const updatedSubEntity = selected || [];
    setSubEntity(updatedSubEntity);
    setFilters((prev) => ({ ...prev, subEntityData: updatedSubEntity }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters(prev => ({ ...prev, monthData: updatedMonths }));
  };

  const handleWeekChange = (selected) => {
    setWeek(selected);
    setFilters(prev => ({ ...prev, weekData: selected }));
  };

  const handleInterCompPageChange = (page) => {
    setInterCompPage(page);
    fetchR2RIntercompanyDrilldownData(page);
  };

  const handleApply = () => {

    const entityFilterData = entity?.value || "";
    const yearFilterData = year?.value || "";

    if (entityFilterData === '') {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    if (yearFilterData === '') {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    setInterCompPage(1);
    fetchR2RIntercompanyDrilldownData(1);
  }

  const fetchR2RIntercompanyDrilldownData = async (page = interCompPage) => {
    setdataLoading(true);
    try {
      const entityFilterData = entity?.value || '';
      const yearFilterData = year?.value || '';
      const subEntityFilterData = subEntity?.map((s) => s?.value) || [];
      const monthFilterData = month?.map((m) => m?.value) || [];

      const limit = itemsPerPage;
      const offset = (page - 1) * limit;

      const response = await axios.post(`${API_BASE_URL}/api/intercompany-drilldown`,
        {
          entity: entityFilterData,
          subEntity: subEntityFilterData,
          year: yearFilterData,
          month: monthFilterData,
          limit: limit,
          offset: offset,
        },
        {
          headers: {
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
      );

      setData(response.data.data);
      setTotalRecords(response.data.total);
    } catch (error) {
      console.error('Error fetching R2R Intercompany Drilldown data:', error);
    } finally {
      setdataLoading(false);
    }
  };

  // const handleCSVDownload = () => {
  //   const csvHeader = columns.map(col => col.header).join(',');
  //   const csvRows = data.map(row =>
  //     columns.map(col => `"${(row[col.accessor] || '').replace(/"/g, '""')}"`).join(',')
  //   );
  //   const csvContent = [csvHeader, ...csvRows].join('\n');
  //   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(blob);
  //   link.download = 'Intercompany.csv';
  //   link.click();
  // };

  const handleCSVDownload = async () => {
    const entityFilterData = entity?.value || '';
    const yearFilterData = year?.value || '';
    const subEntityFilterData = subEntity?.map(s => s.value) || [];
    const monthFilterData = month?.map(m => m.value) || [];

    const response = await axios.post(`${API_BASE_URL}/api/intercompany-drilldown`,
      {
        entity: entityFilterData,
        subEntity: subEntityFilterData,
        year: yearFilterData,
        month: monthFilterData,
        limit: totalRecords,
        offset: 0
      },
      {
        headers: {
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      }
    );

    const allData = response.data.data || [];

    const csvHeader = columns.map(col => col.header).join(',');
    const csvRows = allData.map(row => columns.map(col => `"${(row[col.accessor] || '').toString().replace(/"/g, '""')}"`).join(','));
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Intercompany.csv';
    link.click();
  };

  const handleReset = () => {
    setEntity(null);
    setSubEntity([]);
    setYear(null);
    setMonth([]);
    setWeek(WeekOptions[0]);
    setFilters({
      entityData: null,
      subEntityData: [],
      yearData: null,
      monthData: [],
      weekData: null,
    });
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/R2R-entity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          const allEntities = response.data?.[0]?.all || [];
          setEntityOptions(allEntities);
        });
    } catch (error) {
      console.error("Error fetching R2R-entity options:", error);
    }
  };

  const fetchSubEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/R2R-subEntity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          const subEntities = response.data;
          setSubEntityOptions(subEntities);
        });
    } catch (error) {
      console.error("Error fetching R2R-Sub-Entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/R2R-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching R2R-year options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/R2R-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setMonthOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching R2R-month options:', error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    fetchMonthOptions();
    fetchSubEntityOptions();
  }, []);

  useEffect(() => {
    if (entityOptions.length && subEntityOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.entityData?.value) {
        const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        if (ent) setEntity(ent);
      }

      if (filters.subEntityData && filters.subEntityData.length > 0) {
        const sub = subEntityOptions.filter((opt) =>
          filters.subEntityData.some((s) => s.value === opt.value)
        );
        if (sub.length > 0) setSubEntity(sub);
      }

      if (filters.yearData?.value) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter(opt =>
          filters.monthData.some(m => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.entityData?.value) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, subEntityOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const columns = [
    { header: "Entity", accessor: "entity" },
    { header: "Master Trading Partner", accessor: "master_trading_partner" },
    { header: "Document No", accessor: "document_no" },
    { header: "Reference", accessor: "reference" },
    { header: "Document Data", accessor: "document_date" },
    { header: "Document Type", accessor: "document_type" },
    { header: "Assignment", accessor: "assignment" },
    { header: "Posting Date", accessor: "assignment" },
    { header: "Category", accessor: "category" },
    { header: "Final Amount In LC", accessor: "final_amt_in_lc" },
    { header: "Doc Curr", accessor: "doc_curr" },
    { header: "Final Amount In Doc", accessor: "final_amt_in_doc" },
    { header: "Status", accessor: "status" },
    { header: "Action Owner", accessor: "action_owner" },
    { header: "Department Name", accessor: "department_name" },
    { header: "Remarks", accessor: "remarks" }
  ];

  const [dataLoading, setdataLoading] = useState(false);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
              // styles={customStyles}
              // isMulti={true}
              // closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Sub Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={subEntity}
                onChange={handleSubEntityChange}
                options={subEntityOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
              // styles={customStyles}
              // isMulti={true}
              // closeMenuOnSelect={false}
              />
            </div>
          </div>

          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                styles={customStyles}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div>

          {/* <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Week</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={week}
                onChange={setWeek}
                options={WeekOptions}
                isSearchable={true}
                styles={customStyles}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div> */}

          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div>
        <div className="row" >
          <div className="col-md-12">
            <DomainTile title='Intercompany' showBackButton={true}
              mainPagePath="/Record-To-Report"
              detailState={filters} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              {/* <h2> tabel here</h2> */}
              <ReusableTable
                data={data}
                columns={columns}
                itemsPerPage={itemsPerPage}
                onPageChange={handleInterCompPageChange}
                isCustomOpen={true}
                totalRecords={totalRecords}
                handleCSVDownload={handleCSVDownload}
                dataLoading={dataLoading}
              />
            </DashboardSection>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterCompanyReconcilationDrilldown;
